module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (95).08a4f563.jpg";